<template>
  <div class="filters">
    <div class="categories">
      <button
        v-for="category in categories" :key="category.Name" class="selected">
          {{category.Name}}
      </button>
      <br>
      <span class="cooking-time-display" v-if="recipe.CookingTime">
        <fa icon="clock" /> {{formattedCookingTime}}
      </span>
      <span class="source-link" v-if="recipe.SourceLink">
        <fa icon="link" /> <a :href="recipe.SourceLink" target="_blank">Source</a>
      </span>
    </div>
  </div>
</template>

<script>
  import { functions } from '@/assets/script/functions.js'
  export default {
    props: ['recipe'],
    computed: {
      categories(){
        return functions.getUnique(this.recipe.Categories, 'Name')
      },
      formattedCookingTime() {
        const minutes = this.recipe.CookingTime;
        if (minutes >= 60) {
          const hours = Math.floor(minutes / 60);
          const remainingMinutes = minutes % 60;
          if (remainingMinutes === 0) {
            return `${hours}h`;
          }
          return `${hours}h ${remainingMinutes}min`;
        }
        return `${minutes} min`;
      }
    }
  }
</script>
